module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('b', [_vm._v("ログイン画面")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("勤怠システムのユーザＩＤとパスワードを利用してログインしてください。")]), _c('br'), _c('br'), _vm._v(" "), (this.$router.currentRoute.name == 'login2') ? _c('div', [_vm._v("\n  代理先："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asMemberID),
      expression: "asMemberID"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ユーザＩＤ"
    },
    domProps: {
      "value": (_vm.asMemberID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.asMemberID = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v("\n  ユーザＩＤ："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberID),
      expression: "memberID"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ユーザＩＤ"
    },
    domProps: {
      "value": (_vm.memberID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberID = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\n  パスワード："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "loginBtn"
    },
    on: {
      "click": _vm.signinClick
    }
  }, [_vm._v("ログイン")]), _c('br')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', [_vm._v("３６０評価システム")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e2ef025!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/login.vue
// module id = 116
// module chunks = 2